import React, { FC } from 'react'
import styles from './LayoutsMenu.module.scss'
import { IconType } from '@bt-react/components/Icon'
import classnames from 'classnames'
import LayoutsMenuItem from './LayoutsMenuItem'
import { LayoutType } from '../../../dataStore/slices/layouts/layoutsSlice'
import { mediaType as MediaType } from '@bt-react/constants'

interface LayoutsMenuProps {
  layoutsMenuOpen: boolean
  activeLayoutType: null | LayoutType
  layoutsMenuItemClick: (layoutType: LayoutType) => void
  mediaType: MediaType
}

const LayoutsMenu: FC<LayoutsMenuProps> = ({
  layoutsMenuOpen,
  activeLayoutType,
  layoutsMenuItemClick,
  mediaType
}) => (
  <div
    data-bdd='layouts-menu'
    className={classnames(styles['layouts-menu'], {
      [styles['layouts-menu--open']]: layoutsMenuOpen
  })}>
    <h4>Layout options</h4>
    <p>Set a layout for all presenters and viewers</p>
    <div
      data-bdd='layouts-menu-options'
      className={styles['layouts-menu__options']}>
      {
        (mediaType === MediaType.SPOTLIGHT || mediaType === MediaType.WEBCAM) &&
        <LayoutsMenuItem
          layoutMenuOption={'Gallery'}
          layoutIconName={
            activeLayoutType === LayoutType.Gallery || activeLayoutType === null ?
            IconType.iconName.layoutGridActive : IconType.iconName.layoutGridInactive
          }
          tooltipText={'All presenters in a grid view'}
          layoutType={LayoutType.Gallery}
          layoutsMenuItemClick={layoutsMenuItemClick}
          activeLayoutItem={activeLayoutType === LayoutType.Gallery ? true : false}
        />
      }
      <LayoutsMenuItem
        layoutMenuOption={'Full'}
        layoutIconName={
          activeLayoutType === LayoutType.Full ? IconType.iconName.layoutFullActive :
          IconType.iconName.layoutFullInactive
        }
        tooltipText={'Content or speaker in full view'}
        layoutType={LayoutType.Full}
        layoutsMenuItemClick={layoutsMenuItemClick}
        activeLayoutItem={activeLayoutType === LayoutType.Full ? true : false}
      />
      <LayoutsMenuItem
        layoutMenuOption={'Sidebar'}
        layoutIconName={
          activeLayoutType === LayoutType.Sidebar ? IconType.iconName.layoutSidebarActive :
            IconType.iconName.layoutSidebarInactive
        }
        tooltipText={'Content or speaker side-by-side with all presenters'}
        layoutType={LayoutType.Sidebar}
        layoutsMenuItemClick={layoutsMenuItemClick}
        activeLayoutItem={activeLayoutType === LayoutType.Sidebar ? true : false}
      />
      {
        (mediaType !== MediaType.SPOTLIGHT && mediaType !== MediaType.WEBCAM) &&
        <LayoutsMenuItem
          layoutMenuOption={'Split'}
          layoutIconName={
            activeLayoutType === LayoutType.Split ? IconType.iconName.layoutSplitActive :
              IconType.iconName.layoutSplitInactive
          }
          tooltipText={'Content or speaker side-by-side with spotlighted presenter'}
          layoutType={LayoutType.Split}
          layoutsMenuItemClick={layoutsMenuItemClick}
          activeLayoutItem={activeLayoutType === LayoutType.Split ? true : false}
        />
      }
    </div>
  </div>
)

export default LayoutsMenu
